import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import "./components";

import MuNavMobile from "./components/MuNavMobile";
import MuNavOpenActivePath from "./components/MuNavOpenActivePath";
import MuNavToggles from "./components/MuNavToggles";

// import "bootstrap/js/dist/alert";
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/tooltip';
// import "bootstrap/js/dist/util";

// This is the legacy multisite mobile nav script start

// import ResponsiveTables from "./components/tables";

// Main MU application
class MUApp {
    constructor() {
        this._init();
    }

    _init() {
        console.log("App init");
        this._muNavMobile = new MuNavMobile();
        this._muNavToggle = new MuNavToggles(
            "[mu-nav-site]",
            "> .nav > .has-children"
        );
        this._muNavOpenActivePath = new MuNavOpenActivePath("[mu-nav-site]");
        //this._responsiveTables = new ResponsiveTables();
    }
}

(() => {
    const loadModules = async () => {
        console.log("Loading modules...");
        // Each import() creates a separate chunk that is loaded only when this function runs.
        const { DynamicLoader } = await import("./helpers/dynamic-load");

        // Now execute the functions from the loaded modules
        DynamicLoader(); // Utility method that async loads component scripts

        const muApp = new MUApp();
    };

    document.addEventListener("DOMContentLoaded", loadModules);
})();
// This is the legacy multisite mobile nav script end

/* import 'fancybox';

import dayjs from 'dayjs'
import 'dayjs/locale/en-au'
import 'dayjs/locale/zh-hk'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import advancedFormat from 'dayjs/plugin/advancedFormat'
*/

/* fontawesome tree shaking NOT working for IE 10
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { faUser, faCopyright } from "@fortawesome/free-regular-svg-icons";
import { faFontAwesome } from "@fortawesome/free-brands-svg-icons";

library.add(faCamera, faUser, faCopyright,faFontAwesome);
dom.watch() */

// import Player from '@vimeo/player';

/* Examples
import PageModel from './components/models/PageModel';
var Nav = require('./components/Nav').default,

PageModel.init();

var nav = new Nav(siteSearch);
nav.init();

import 'fancybox';
import 'kendoTimezones';

(()=>{

   $(".fancybox").fancybox();
   var targetDate = new Date(2016,10,5,15,25,11);
   var convertedDate1 = kendo.timezone.apply(targetDate, "Etc/GMT-6");
   var convertedDate2 = kendo.timezone.apply(targetDate, -360);

   // Sat Nov 05 2016 23:25:11 GMT+0200 (FLE Standard Time);
   console.log(convertedDate1);
   // Sat Nov 05 2016 23:25:11 GMT+0200 (FLE Standard Time);
   console.log(convertedDate2);
   console.log("day.js---------------------");
   dayjs.extend(localizedFormat)
   dayjs.extend(advancedFormat)
   console.log(dayjs(new Date()).locale('en-au').format('LLLLZ'));
   console.log(dayjs(new Date()).locale('zh-hk').format('LLLLZ'));
})();
*/

// import $ from "jquery";

// set jquery to global
// global.$ = global.jQuery = $;
// window.jQuery = $;

// Specify which plugins you need
/* ;
import "bootstrap/js/dist/popover";
import "bootstrap/js/dist/scrollspy";
// import "bootstrap/js/dist/button";
*/
